class PurchaseRecordController {
  constructor (I18n, ProductUtilsService) {
    'ngInject'
    this.I18n = I18n
    this.productUtilsService = ProductUtilsService
  }

  get button () {
    const { record } = this
    return this.productUtilsService.getButtonLabel(record)
  }

  get expirationDate () {
    const { record } = this
    return record && record.expirationDate ? new Date(record.expirationDate) : null
  }

  get purchaseDate () {
    const { record } = this
    return record && record.purchaseDate ? new Date(record.purchaseDate) : null
  }
}

export default PurchaseRecordController



// WEBPACK FOOTER //
// ./src/app/pages/vehicle/manage-my-rlink/components/purchase-record/purchase-record.controller.js